export default function () {
    if(process.env.VUE_APP_REGION === 'US'){
        return 'us';
    }else{
        return 'au';
    }
}


